<script setup>
import { useToast } from 'primevue/usetoast'
import { computed, nextTick, watch } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import { useToastMessages } from '@/composables/useToastMessages'

const { t } = useI18n()

const page = usePage()
const toast = useToast()
const showToastMessages = useToastMessages()

/** Flash messages from backend session */

const toastMessages = computed(() => page.props.toasts ?? [])
watch(toastMessages, (messages) => {
  if (!messages.length) return

  showToastMessages(messages)
})

/** Validation errors from useFrom() */

const errors = computed(() => page.props.errors)
watch(errors, async (err) => {
  if (!err) return

  await nextTick()

  Object.entries(err).forEach(([, value], index) => {
    setTimeout(() => {
      toast.add({
        severity: 'error',
        summary: t('error'),
        detail: value,
        life: 5000,
      })
    }, index * 100)
  })
})
</script>

<template>
  <Toast position="bottom-right" />
</template>

<i18n>
{
  "de": {
    "error": "Fehler"
  },
  "en": {
    "error": "Error"
  }
}
</i18n>
